<template>
    <md-toolbar v-if="position === 'top'">
        <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">

                <md-button class="md-icon-button" to="/to/">
                    <md-icon>home</md-icon>
                    <md-tooltip md-direction="bottom">Home</md-tooltip>
                </md-button>

            </div>
            <div class="md-headline">
                <b>Ponderosa Software</b>
                <span class="md-xsmall-hide"> UG (haftungsbeschränkt)</span>
            </div>
            <div class="md-toolbar-section-end">

                <md-button class="md-icon-button" to="/to/kontakt">
                    <md-icon>contact_mail</md-icon>
                    <md-tooltip md-direction="bottom">Kontakt</md-tooltip>
                </md-button>

                <md-button class="md-icon-button" to="/" v-if="isLoggedIn()">
                    <md-icon>power_settings_new</md-icon>
                    <md-tooltip md-direction="bottom">Abmelden</md-tooltip>
                </md-button>

            </div>
        </div>
    </md-toolbar>
    <md-toolbar class="md-dense" v-else-if="position === 'bottom'">
        <div class="md-toolbar-row md-dense">
            <div class="md-toolbar-section-start">

                <md-button to="/to/impressum">
                    Impressum
                </md-button>

                <md-button to="/to/datenschutz">
                    Datenschutz
                </md-button>

            </div>
            <div class="md-toolbar-section-end">
                <small class="md-xsmall-hide">
                    Copyright &copy; {{ getCopyrightYears() }}
                </small>
                <small class="md-small-hide">
                    &nbsp;by <a href="https://www.ponderosa-software.de" target="_blank">Ponderosa Software UG (haftungsbeschränkt)</a>
                </small>
            </div>
        </div>
    </md-toolbar>
    <div v-else>

        <p class="md-title">
            Hauptmenü
        </p>

        <p>
            <router-link to="/to/">
                <md-icon class="left-menu">home</md-icon>
                <span class="left-menu">Home</span>
            </router-link>
        </p>

        <p>
            <router-link to="/to/kontakt">
                <md-icon class="left-menu">contact_mail</md-icon>
                <span class="left-menu">Kontakt</span>
            </router-link>
        </p>

        <p>
            <router-link to="/to/impressum">
                <md-icon class="left-menu">copyright</md-icon>
                <span class="left-menu">Impressum</span>
            </router-link>
        </p>

        <p>
            <router-link to="/to/datenschutz">
                <md-icon class="left-menu">policy</md-icon>
                <span class="left-menu">Datenschutz</span>
            </router-link>
        </p>

    </div>
</template>

<script>
    // REMARK: route '/to/xxx' will be changes by router.js to '/xxx'
    // this is necessary to change scrollbar even if you go on the same router link
    export default {
        name: "Navigation",
        props: [ "position" ],
        methods: {
            isLoggedIn() {
                return false;
            },
            getCopyrightYears() {
                var currentYear = new Date().getFullYear();
                return (currentYear > 2019) ? '2019 - ' + currentYear : '2019';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .left-menu {
        padding-left: 20px;
    }
</style>
